import baseButton, { getCommonStyleSheet } from '@bubble-ui/temp-base-button';

var primaryColors = function primaryColors() {
  return {
    backgroundColorToken: 'colors/backgrounds/inverse',
    focusBorderColorToken: 'colors/borders/default',
    textColorToken: 'colors/text/inverse',
    loaderInverted: true
  };
};

export default baseButton('ButtonPrimary', getCommonStyleSheet(primaryColors));
//# sourceMappingURL=index.js.map